import React from "react";
import { css } from "@emotion/css";
import { CurrentSubscriptionResponse } from "@remotes/fetchCurrentSubscription";

interface CreditsSectionProps {
  subscription: CurrentSubscriptionResponse;
  isTrial: () => boolean;
}

export const CreditsSection: React.FC<CreditsSectionProps> = ({ subscription, isTrial }) => {
  const shouldShowImageLimit = !isTrial() && subscription.image_credits <= subscription.product.image_credits;
  const shouldShowStyleLimit = !isTrial() && subscription.style_credits <= subscription.product.style_credits;
  
  return (
    <div className={creditsGridStyle}>
      <div className={creditCardStyle}>
        <div className={creditIconStyle}>🎨</div>
        <div className={creditInfoStyle}>
          <span className={creditLabelStyle}>Image Credits</span>
          <span className={creditValueStyle}>{subscription.image_credits}</span>
          {isTrial() ? (
            <span className={creditTotalStyle}>Trial</span>
          ) : shouldShowImageLimit ? (
            <span className={creditTotalStyle}>of {subscription.product.image_credits}</span>
          ) : null}
        </div>
      </div>
      <div className={creditCardStyle}>
        <div className={creditIconStyle}>✨</div>
        <div className={creditInfoStyle}>
          <span className={creditLabelStyle}>Style Credits</span>
          <span className={creditValueStyle}>{subscription.style_credits}</span>
          {isTrial() ? (
            <span className={creditTotalStyle}>Trial</span>
          ) : shouldShowStyleLimit ? (
            <span className={creditTotalStyle}>of {subscription.product.style_credits}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const creditsGridStyle = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
`;

const creditCardStyle = css`
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  gap: 16px;
`;

const creditIconStyle = css`
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
`;

const creditInfoStyle = css`
  flex: 1;
`;

const creditLabelStyle = css`
  font-size: 12px;
  color: #adadad;
  font-weight: 500;
  text-transform: uppercase;
  display: block;
  margin-bottom: 4px;
`;

const creditValueStyle = css`
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  display: block;
  margin-bottom: 2px;
`;

const creditTotalStyle = css`
  font-size: 12px;
  color: #adadad;
  font-weight: 500;
`; 